// extracted by mini-css-extract-plugin
export default {"control-panel":"controlPanel_control-panel__f8OIr"};